<script setup>
import { computed } from 'vue'

const props = defineProps({
  dialog: { required: true },
  text: { required: false, default: 'Download?' },
  content: { required: false, default: 'Do you want to download the file?' },
  loading: { required: false, default: false },
  width: { required: false, default: 500 }
})

const editableDialog = computed({
  get() {
    return props.dialog
  },
  set(value) {
    emit('update:dialog', value)
  }
})

const emit = defineEmits(['download'])
</script>

<template>
  <v-dialog v-model="editableDialog" :width="width">
    <v-card>
      <v-card-title class="pt-4"> {{ text }}</v-card-title>
      <v-card-text class="pl-4 pt-0" v-html="content"> </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" color="primary" @click="$emit('download')"> Download </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
